import { render, staticRenderFns } from "./Crowdfunding.vue?vue&type=template&id=99b01768&scoped=true"
import script from "./Crowdfunding.vue?vue&type=script&lang=js"
export * from "./Crowdfunding.vue?vue&type=script&lang=js"
import style0 from "./Crowdfunding.vue?vue&type=style&index=0&id=99b01768&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b01768",
  null
  
)

export default component.exports